<template>
    <v-app style="background-color: #f3f6f9">
        <v-main>
           
            <SimsComp />

        </v-main>
    </v-app>
</template>
<script>
import Auth from '@/services/auth.service.js'
import SimsComp from '@/components/sims/SimsComp.vue'

export default {
    components: {
        SimsComp,
    },
    data() {
        return {
        };
    },
    methods: {
    },
    computed: {
    },
    mounted() {
        document.title = 'סימים | סים לחומרא'
        let auth = Auth.checkAuth();
        if (!auth) {
            return this.$router.replace({ name: "login" })
        }
    },
}
</script>
<style>
</style>